module.exports = __webpack_public_path__ + "img/next_task.09a1f4e2.svg";